// { type : 'routeMsg', message : { type : 'reasonRunScript', foo : 'bar' }, options : { reasoner : { id : script.id } } }

import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import pathUtil from '@leverege/path'
import { Selector } from '@leverege/ui-elements';
import { TextInput, Flex, LabelGroup, InsetSection, JsonEditorDialog, Section } from '~/views';

import style from './style.css'
import { registry } from './Factory'

export default class PublishTopicEditor extends React.Component {
  static TYPE = 'triggerScript';

  static NAME = 'Trigger Script';

  static DEFAULTS = {
    type : 'publishTopic',
    topic : 'reason',
    message : { 
      type : 'routeMsg',
      message : {
        type : 'reasonRunScript',
      },
      options : { 
        reasoner : { 
          id : null,
          targetFunction : null,
          foo : 'bar'
        } 
      }
    }
  }

  constructor( props ) {
    super( props )
    this.state = {
      showDialog : false
    }
  }

  changePath = ( path, value, err, override = false ) => {
    if ( err ) {
      console.log( `error setting ${path} to ${value}`, err )
      this.props.onError( path, value, err )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange( { target : this.props.timer, path, value }, override );
    }
  }

  render() {
    // this.baseTimer.changePath( 'timer/when', v, err )
    const { timer } = this.props
    const { showDialog } = this.state
    const actionObj = timer.action

    const types = Object.keys( registry ).map( ( value ) => {
      return { value, name : registry[value].NAME }
    } )

    const scriptId = pathUtil( 'message/options/reasoner/id' ).get( actionObj, null )
    const targetFunction = pathUtil( 'message/options/reasoner/targetFunction' ).get( actionObj, null )

    let messageOptions = pathUtil( 'message/options/reasoner' ).get( actionObj, null )
    messageOptions = { ...messageOptions }
    delete messageOptions.id
    delete messageOptions.targetFunction

    const message = pathUtil( 'message/message' ).get( actionObj, null )

    return (
      <div>
        <Section title="Action">
          <Flex variant="vSpace" align="stretch" direction="column">
            <LabelGroup>
              <label>Type</label>
              <Selector
                values={types}
                value={PublishTopicEditor.TYPE}
                onChange={( value ) => { this.changePath( 'action/type', value.value, false, true ); }} />
            </LabelGroup>
            <LabelGroup>
              <label>Script Id</label>
              <TextInput
                value={scriptId}
                changeOnReturn
                size={10}
                onChange={value => this.changePath( 'action/message/options/reasoner/id', value, false )} />
            </LabelGroup>
            <LabelGroup>
              <label>Target Func</label>
              <TextInput
                value={targetFunction}
                changeOnReturn
                size={10}
                onChange={value => this.changePath( 'action/message/options/reasoner/targetFunction', value.length == 0 ? null : value, false )} />
            </LabelGroup>
            <LabelGroup vertical>
              <label>Message</label>
              <InsetSection style={{ width : '100%' }}>
                <div className={actionObj.message ? style.metadata : style.noMetadata}>{ ( message && JSON.stringify( message ) ) || 'No Message' }</div> 
                <Button style={{ float : 'right' }} bsSize="sm" onClick={() => { this.setState( { showDialog : 'message' } ) }}>Edit</Button>
              </InsetSection>
            </LabelGroup>
            <LabelGroup vertical>
              <label>Options</label>
              <InsetSection style={{ width : '100%' }}>
                <div className={actionObj.message ? style.metadata : style.noMetadata}>{ ( messageOptions && JSON.stringify( messageOptions ) ) || 'No Message' }</div> 
                <Button style={{ float : 'right' }} bsSize="sm" onClick={() => { this.setState( { showDialog : 'options' } ) }}>Edit</Button>
              </InsetSection>
            </LabelGroup>
          </Flex>
          <JsonEditorDialog 
            title="Function Options Object"
            message="Enter the JSON object to be given as options to the function"
            show={showDialog} 
            onOk={( val ) => {
              if ( showDialog === 'options' ) {
                if ( val ) {
                  val.id = scriptId
                  val.targetFunction = targetFunction
                }
                this.changePath( 'action/message/options/reasoner', val, false )
                this.setState( { showDialog : false } ) 
              } else {
                this.changePath( 'action/message/message', val, false )
                this.setState( { showDialog : false } )
              }
            }}
            onCancel={() => { this.setState( { showDialog : false } ) }}
            value={showDialog === 'options' ? messageOptions : message} />
        </Section>
      </div>
    )
  }
}
